<template>
<div class="yin-yang-related-chart-group">
  <div class="yin-yang-related-chart">
    <div class="yin-yang-related-chart-header">
      <span>颗粒态阴离子</span>
      <span>VS</span>
      <span>颗粒态阳离子</span>
    </div>

    <div>
      <related-chart :base-data="pmYinYangRelatedDataMap[0]" :related-data="pmYinYangRelatedDataMap[1]" />
    </div>
  </div>

  <div class="yin-yang-related-chart">
    <div class="yin-yang-related-chart-header">
      <span>气态阴离子</span>
      <span>VS</span>
      <span>气态阳离子</span>
    </div>

    <div>
      <related-chart :base-data="gasYinYangRelatedDataMap[0]" :related-data="gasYinYangRelatedDataMap[1]" />
    </div>
  </div>
</div>
</template>

<script>
export const P_YIN_YANG_CONFIG = Object.freeze({
  // Na+
  6107: {
    type: 1,
    weight: 23
  },
  // NH4+
  6108: {
    type: 1,
    weight: 18
  },
  // K+
  6109: {
    type: 1,
    weight: 39
  },
  // Mg2+
  6110: {
    type: 1,
    weight: 12
  },
  // Ca2+
  6111: {
    type: 1,
    weight: 20
  },
  // SO42-
  6104: {
    type: 0,
    weight: 48
  },
  // NO3-
  6103: {
    type: 0,
    weight: 62
  },
  // Cl-
  6101: {
    type: 0,
    weight: 35.5
  },
  // F-
  6100: {
    type: 0,
    weight: 19
  }
})

export const G_YIN_YANG_CONFIG = Object.freeze({
  // Na+
  6120: {
    type: 1,
    weight: 23
  },
  // NH4+
  6121: {
    type: 1,
    weight: 18
  },
  // K+
  6122: {
    type: 1,
    weight: 39
  },
  // Mg2+
  6123: {
    type: 1,
    weight: 12
  },
  // Ca2+
  6124: {
    type: 1,
    weight: 20
  },
  // SO42-
  6117: {
    type: 0,
    weight: 48
  },
  // NO3-
  6116: {
    type: 0,
    weight: 62
  },
  // Cl-
  6114: {
    type: 0,
    weight: 35.5
  },
  // F-
  6113: {
    type: 0,
    weight: 19
  }
})

export default {
  name: 'YinYangRelatedChartGroup',
  props: {
    siteData: {
      required: true,
      type: Object
    }
  },
  computed: {
    pmYinYangRelatedDataMap () {
      return this.getRelatedData(P_YIN_YANG_CONFIG)
    },
    gasYinYangRelatedDataMap () {
      return this.getRelatedData(G_YIN_YANG_CONFIG)
    }
  },
  methods: {
    getRelatedData (YIN_YANG_CONFIG) {
      let {siteData} = this
      let yinYangRelated = [{
        id: 'anions',
        name: '阴离子',
        unit: 'μmol/m3',
        data: []
      }, {
        id: 'cations',
        name: '阳离子',
        unit: 'μmol/m3',
        data: []
      }]

      let anionsData = yinYangRelated[0].data
      let cationsData = yinYangRelated[1].data
      let {dataTimes} = siteData
      let dataTimesLen = dataTimes.length
      let series = Object.entries(siteData.seriesMap).filter(([factorId]) => YIN_YANG_CONFIG[factorId])
      let seriesLen = series.length

      for (let i = 0; i < dataTimesLen; i++) {
        let dataTime = dataTimes[i][1]
        let yinYangValues = [{
          dataTime,
          value: null
        }, {
          dataTime,
          value: null
        }]
        anionsData.push(yinYangValues[0])
        cationsData.push(yinYangValues[1])

        for (let j = 0; j < seriesLen; j++) {
          let seriesItem = series[j]
          let data = seriesItem[1][dataTime]

          if (!data) {
            continue
          }

          let [factorId] = seriesItem
          let yinYangConfig = YIN_YANG_CONFIG[factorId]
          let calcVal = data.value / yinYangConfig.weight
          let yinYangData = yinYangValues[yinYangConfig.type]
          let yinYangValue = yinYangData.value
          yinYangData.value = Number.isFinite(yinYangValue) ? (yinYangValue + calcVal) : calcVal
        }
      }

      return yinYangRelated
    }
  }
}
</script>

<style lang="scss">
.yin-yang-related-chart-group {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .yin-yang-related-chart {
    display: grid;
    grid-template-rows: var(--related-chart-header-height) var(--related-chart-width);

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .yin-yang-related-chart-header {
      font-size: 18px;
      display: grid;
      grid-template-columns: repeat(3, max-content);
      grid-column-gap: .5em;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/YinYangRelatedChartGroup.vue